import React from "react";
import Button from "@components/Common/Buttons/Button";

interface InvestmentProfileActionsProps {
  isUserEnrolled?: boolean;
  isSubmitting: boolean;
  onPrevious: () => void;
  onSubmit: () => void;
}

const InvestmentProfileActions: React.FC<InvestmentProfileActionsProps> = ({
  isUserEnrolled,
  isSubmitting,
  onPrevious,
  onSubmit,
}) => {
  return (
    <div
      className={`flex items-center space-x-4 lg:space-x-0 bg-white ${
        isUserEnrolled
          ? "gap-4"
          : "justify-between mt-[24px] md:shadow-md rounded-[16px] px-0 py-[32px] md:p-[32px]"
      }`}
    >
      <div className={`${isUserEnrolled ? "w-full" : "w-[218px]"}`}>
        <Button
          ariaLabel="previous"
          variant="secondary"
          label="Previous"
          iconAlignment="left"
          handleClick={onPrevious}
        />
      </div>
      {!isUserEnrolled && (
        <div className="hidden lg:block flex-1 text-center">
          <p className="leading-[127%] font-normal text-[14px] text-[#C6C6C6]">
            4 out of 4
          </p>
        </div>
      )}
      <div className={`${isUserEnrolled ? "w-full" : "w-[218px]"}`}>
        <Button
          iconVisibility="show"
          ariaLabel="Save & Continue"
          label="Save & Continue"
          loading={isSubmitting}
          handleClick={onSubmit}
        />
      </div>
    </div>
  );
};

export default InvestmentProfileActions;
